// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PostAttachmentViewer_attachmentContainer__-EJhh {
  position: relative;
  display: inline-block;
  margin-top: 4px;
}

.PostAttachmentViewer_fileName__4RxC3 {
  color: #0073b1;
  cursor: pointer;
  font-size: 14px;
}
.PostAttachmentViewer_textName__7RYOK{
  color: #373334;
  cursor: pointer;
  font-size: 14px;
}
.PostAttachmentViewer_tooltip__jCoIv {
  position: relative;
  background: #fff;
  border-radius: 10px;

  /* Size controls */
  width: 200px; /* Adjust tooltip width here */
  max-width: 90vw; /* Responsive limit: 90% of viewport width */
  padding: 32px 16px 16px; /* top padding gives space below close button */

  /* Layout for buttons */
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align all buttons/text to left */
  gap: 10px !important; /* space between each option */
}
/* Larger arrow tip (points to trigger element) */
.PostAttachmentViewer_tooltip__jCoIv::before {
  content: "";
  position: absolute;
  top: -22px; /* move arrow higher above tooltip */
  left: 24px; /* adjust for horizontal alignment */
  border-width: 12px; /* bigger arrow height and width */
  border-style: solid;
  border-color: transparent transparent #fff transparent;
  filter: drop-shadow(0 -1px 1px rgba(0, 0, 0, 0.1));
}
/* .backdrop {
  position: fixed;
  inset: 0;
  z-index: 999;
} */




.PostAttachmentViewer_tooltip__jCoIv button {
  background: none;
  border: none;
  cursor: pointer;
  color: #212529;
  font-size: 14px;
  text-align: left;
  padding: 4px 0;
  transition: color 0.2s ease;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  outline: none !important;
}
.PostAttachmentViewer_tooltip__jCoIv label {
  background: none;
  border: none;
  cursor: pointer;
  color: #212529;
  font-size: 14px;
  text-align: left;
  padding: 4px 0;
  transition: color 0.2s ease;
}
.PostAttachmentViewer_fileView__alku2 {
  margin-left: 8px;
}
.PostAttachmentViewer_fileViewIcon__t0yxm{
  font-size: 18px;
}
.PostAttachmentViewer_tooltip__jCoIv button:hover {
  text-decoration: underline;
}
.PostAttachmentViewer_tooltipClose__f7\\+Qh {
  position: absolute; /* stays in top-right corner */
  top: 8px;
  right: 10px;
  background: none;
  border: none;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  color: #555;
  transition: color 0.2s ease;
  outline: none !important;
}

/* 🔸 Hover state for close button */
.PostAttachmentViewer_tooltipClose__f7\\+Qh:hover {
  color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/home/PostAttachmentViewer.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;;EAEnB,kBAAkB;EAClB,YAAY,EAAE,8BAA8B;EAC5C,eAAe,EAAE,4CAA4C;EAC7D,uBAAuB,EAAE,+CAA+C;;EAExE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,mCAAmC;EAC5D,oBAAoB,EAAE,8BAA8B;AACtD;AACA,iDAAiD;AACjD;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU,EAAE,oCAAoC;EAChD,UAAU,EAAE,oCAAoC;EAChD,kBAAkB,EAAE,kCAAkC;EACtD,mBAAmB;EACnB,sDAAsD;EACtD,kDAAkD;AACpD;AACA;;;;GAIG;;;;;AAKH;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB,EAAE,8BAA8B;EAClD,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,WAAW;AACb","sourcesContent":[".attachmentContainer {\r\n  position: relative;\r\n  display: inline-block;\r\n  margin-top: 4px;\r\n}\r\n\r\n.fileName {\r\n  color: #0073b1;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n.textName{\r\n  color: #373334;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n.tooltip {\r\n  position: relative;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n\r\n  /* Size controls */\r\n  width: 200px; /* Adjust tooltip width here */\r\n  max-width: 90vw; /* Responsive limit: 90% of viewport width */\r\n  padding: 32px 16px 16px; /* top padding gives space below close button */\r\n\r\n  /* Layout for buttons */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start; /* Align all buttons/text to left */\r\n  gap: 10px !important; /* space between each option */\r\n}\r\n/* Larger arrow tip (points to trigger element) */\r\n.tooltip::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: -22px; /* move arrow higher above tooltip */\r\n  left: 24px; /* adjust for horizontal alignment */\r\n  border-width: 12px; /* bigger arrow height and width */\r\n  border-style: solid;\r\n  border-color: transparent transparent #fff transparent;\r\n  filter: drop-shadow(0 -1px 1px rgba(0, 0, 0, 0.1));\r\n}\r\n/* .backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 999;\r\n} */\r\n\r\n\r\n\r\n\r\n.tooltip button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #212529;\r\n  font-size: 14px;\r\n  text-align: left;\r\n  padding: 4px 0;\r\n  transition: color 0.2s ease;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  outline: none !important;\r\n}\r\n.tooltip label {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #212529;\r\n  font-size: 14px;\r\n  text-align: left;\r\n  padding: 4px 0;\r\n  transition: color 0.2s ease;\r\n}\r\n.fileView {\r\n  margin-left: 8px;\r\n}\r\n.fileViewIcon{\r\n  font-size: 18px;\r\n}\r\n.tooltip button:hover {\r\n  text-decoration: underline;\r\n}\r\n.tooltipClose {\r\n  position: absolute; /* stays in top-right corner */\r\n  top: 8px;\r\n  right: 10px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  color: #555;\r\n  transition: color 0.2s ease;\r\n  outline: none !important;\r\n}\r\n\r\n/* 🔸 Hover state for close button */\r\n.tooltipClose:hover {\r\n  color: #000;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attachmentContainer": `PostAttachmentViewer_attachmentContainer__-EJhh`,
	"fileName": `PostAttachmentViewer_fileName__4RxC3`,
	"textName": `PostAttachmentViewer_textName__7RYOK`,
	"tooltip": `PostAttachmentViewer_tooltip__jCoIv`,
	"fileView": `PostAttachmentViewer_fileView__alku2`,
	"fileViewIcon": `PostAttachmentViewer_fileViewIcon__t0yxm`,
	"tooltipClose": `PostAttachmentViewer_tooltipClose__f7+Qh`
};
export default ___CSS_LOADER_EXPORT___;
